<template>
  <div class="dynamic-fields-info-table" v-if="!onlyRows">
    <table v-if="hasMasterLanguage && dynamicFieldsTemplate" class="table table-sm mb-0">
      <tr v-for="dynamicField in dynamicFieldsTemplate" :key="dynamicField.key">
        <template v-if="!skipEmptyValues || dynamicFields[masterLanguage.key][dynamicField.key]">
          <td class="font-weight-bold border-bottom border-top-0">
            {{ dynamicField.label }}
          </td>
          <td class="border-bottom border-top-0" v-if="dynamicField.type === 'checkbox'">
        <span v-as-status="dynamicFields[masterLanguage.key][dynamicField.key] ? 'checked' : 'unchecked'">
          {{ dynamicFields[masterLanguage.key][dynamicField.key] ? $t('Yes') : $t('No') }}
        </span>
          </td>
          <td class="border-bottom border-top-0" v-else-if="dynamicField.type === 'select2' && dynamicField.field_class_name !== 'MainField'">
            {{ getDynamicFieldValue(dynamicFields, dynamicField) }}
          </td>
          <td class="border-bottom border-top-0" v-else>
            {{ dynamicFields | attributeByMasterLanguage(dynamicField.key) | striptags | truncate(200) }}
          </td>
        </template>
      </tr>
    </table>
  </div>
  <tbody v-else>
  <template v-if="hasMasterLanguage && dynamicFieldsTemplate">
    <tr v-for="dynamicField in dynamicFieldsTemplate" :key="`dynamic-field-info-table-${dynamicField.key}`">
      <template v-if="!skipEmptyValues || dynamicFields[masterLanguage.key][dynamicField.key]">
        <td class="font-weight-bold border-bottom border-top-0">
          {{ dynamicField.label }}
        </td>
        <td class="border-bottom border-top-0" v-if="dynamicField.type === 'checkbox'">
            <span v-as-status="dynamicFields[masterLanguage.key][dynamicField.key] ? 'checked' : 'unchecked'">
              {{ dynamicFields[masterLanguage.key][dynamicField.key] ? $t('Yes') : $t('No') }}
            </span>
        </td>
        <td class="border-bottom border-top-0" v-else-if="dynamicField.type === 'select2'">
          {{ getDynamicFieldValue(dynamicFields, dynamicField) }}
        </td>
        <td class="border-bottom border-top-0" v-else>
          {{ dynamicFields | attributeByMasterLanguage(dynamicField.key) | striptags | truncate(200) }}
        </td>
      </template>
    </tr>
  </template>
  </tbody>
</template>

<script>
  import i18nHelper from "@/core/services/i18n.service";

  export default {
    name: "DynamicFieldsInfoTable",
    props: {
      dynamicFields: {
        type: [Object, Array],
        required: true
      },
      dynamicFieldsTemplate: {
        type: [Object, Array],
        required: true
      },
      onlyRows: {
        type: Boolean,
        default: false
      },
      skipEmptyValues: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        masterLanguage: i18nHelper.getMasterLanguage()
      }
    },
    computed: {
      hasMasterLanguage() {
        return this.dynamicFields && this.dynamicFields[this.masterLanguage.key];
      }
    },
    methods: {
      getDynamicFieldValue(item, dynamicField) {
        let choices = {}
        if (dynamicField.rules && dynamicField.rules.choices) {
          dynamicField.rules.choices.forEach(choice => choices[choice.value] = choice.key)
        }
        const value = item[this.masterLanguage.key][dynamicField.key];

        if (dynamicField.field_class_name === 'MultipleChoiceField' && Array.isArray(value)) {
          return value.map(v => choices[v]).join(', ')
        }

        let selectedOption = choices[value]

        if (typeof selectedOption === 'object' && selectedOption[this.masterLanguage.key]) {
          return selectedOption[this.masterLanguage.key]
        }

        return choices[value];
      }
    }
  }
</script>

<style scoped>

</style>
